module.exports = __webpack_public_path__ + "static/media/290838.8d07f202.png";